import { createContext, useContext } from 'react';
import type { ResolvedPortalConfig } from '../types/portal-config';

export const PortalCoreContext = createContext<ResolvedPortalConfig | null>(null);

/**
 * Returns the resolved portal config. Must be called inside PortalCoreProvider.
 */
export const usePortalConfig = (): ResolvedPortalConfig => {
  const ctx = useContext(PortalCoreContext);
  if (!ctx) {
    throw new Error('usePortalConfig must be used within PortalCoreProvider');
  }
  return ctx;
};
